import { CircularProgress } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { RouteComponentProps } from "@reach/router";
import { ExpensiveSource } from "@authory-packages/core";
import React, { useEffect, useState } from "react";
import { Api } from "../lib/api";
import { Layout } from "./Layout";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export const ExpensiveSourceView = (props: RouteComponentProps) => {
  const [expensiveSources, setExpensiveSources] = useState<ExpensiveSource[]>(
    []
  );
  const classes = useStyles();

  const fetchData = async () => {
    const res = await Api.getExpensiveSources();
    setExpensiveSources(res.data.sources);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderEmptyDetails = () => {
    return (
      <React.Fragment>
        <TableCell />
        <TableCell />
      </React.Fragment>
    );
  };

  const renderDetails = (source: ExpensiveSource) => {
    return (
      <>
        <TableCell align="left">
          <Link href={`/user/${source.userSlug}#Root${source.rootId}`}>
            {source.userSlug} / Root{source.rootId}
          </Link>
        </TableCell>
        <TableCell align="left">{source.importedCount}</TableCell>
      </>
    );
  };

  return (
    <Layout title={`Expensive Sources`}>
      {expensiveSources.length === 0 ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <p style={{ margin: 12 }}>
            This list shows the 50 sources which generated the most new URLs in
            the last 24 hours. A healthy value is below 50.
            <br />
            The higher the value, the higher the cost on our end.
          </p>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }} align="left">
                  Source
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="left">
                  Imported (24h)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {expensiveSources.map((source) => (
                <TableRow key={String(source.rootId)}>
                  {renderDetails(source)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Layout>
  );
};
